import { services } from '../services';
var action = "report/";

export const bookingReportService = {
    getExpiredBooking,
    getDailyBooking
};



function getExpiredBooking(param = '', uri='booking-expired') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getDailyBooking(param = '', uri='booking-daily') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

